import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { CategoryDto } from '@/api';
import { StoreResponse, StoreResponses } from '@/stores/response';
import { categoriesApi } from '@/stores/api';
import ErrorKey from '@/util/ErrorKey';
import { CategoryMap } from '@/stores/search/util';

@Module({
  namespaced: true,
  name: 'CategoryStore',
})
export default class CategoryStore extends VuexModule {
  private parentCategories: CategoryDto[] = [];
  private subCategories: CategoryMap[] = [];

  public get rootCategories() {
    return this.parentCategories;
  }

  public get categories(): CategoryMap[] {
    return this.subCategories;
  }

  @Mutation
  public setRootCategories(categories: CategoryDto[]) {
    this.parentCategories = categories;
  }

  @Mutation
  public setAllCategories(categories: CategoryDto[]) {
    const list: CategoryMap[] = [];
    this.parentCategories.forEach((par) => {
      const parents = categories.filter((cat) => cat.parentId === par.id);
      parents.forEach((subParent) => {
        const children = categories.filter((subCat) => subCat.parentId === subParent.id);
        list.push({category: subParent, children});
      });
    });
    this.subCategories = list.sort((a, b) => b.children.length - a.children.length);
  }

  @Action
  public async fetchRootCategories(): Promise<StoreResponse<CategoryDto[]>> {
    try {
      const response = await categoriesApi.getRootCategories('GRM', true);
      this.context.commit('setRootCategories', response.data);
      return StoreResponses.apiSuccess(response);
    } catch (e) {
      return StoreResponses.error(e, ErrorKey.CategoriesFetchAction);
    }
  }

  @Action
  public async fetchAllCategories(): Promise<StoreResponse<CategoryDto[]>> {
    try {
      const response = await categoriesApi.getAllSubCategories('GRM', true);
      this.context.commit('setAllCategories', response.data);
      return StoreResponses.apiSuccess(response);
    } catch (e) {
      return StoreResponses.error(e, ErrorKey.CategoriesFetchAction);
    }
  }
}
